import { staticFont } from '../../../../shared/typography';
import { html } from 'rune-ts';
import { UtilS } from '../../../../../../modules/Util/S/Function/module/UtilS';
import { getResizedUrl } from '../../../../shared/util/image';
import { dateFromNow } from '../../../../shared/util/date';
import { format } from 'date-fns';

export type Platform = 'pc' | 'mobile';

export class CoverBanner {
  public static readonly typo: Record<Platform, string> = {
    pc: staticFont('bebas_150_bold'),
    mobile: staticFont('bebas_40_bold'),
  };

  public static resolvePlatform(is_mobile: boolean): Platform {
    return is_mobile ? 'mobile' : 'pc';
  }

  public static toText(text: string) {
    return html.preventEscape(UtilS.escape(text, true));
  }

  public static resizeImage(url: string) {
    return getResizedUrl({
      url,
      quality: 80,
      width: 600,
    });
  }

  public static formatDiffDate(date: Date) {
    return dateFromNow(date);
  }

  public static formatDate(date: Date): string {
    return format(new Date(date), 'yyyy.MM.dd HH:mm');
  }
}
